import React, { Component } from "react";
import axios from "axios";
import { PaginatedItems } from "../../components/Paginated";
import Loader from "../../components/Loader";
import { Autocomplete, TextField } from "@mui/material";
import { GrDocumentCsv } from "react-icons/gr";
import { PathCustom } from "../../Path/Path";
import { toast } from "react-toastify";

export default class BoxLabelPrintedItems extends Component {
    state = {
        printingItems: [],
        printingItemsFilter: [],
        itemsPerPage: 10,
        loading: false,
        toDate: null,
        fromDate: null,
        refresh: false,
        paginationData: {},
        poNumber: "",
        sku: '',
        users: '',
        po_number: '',
        invoice_number: '',
        barcode: ''
    }
    getPrintedItems = async (pageNumber = 1) => {
        const poNumber = this.state.poNumber
        const sku = this.state.sku
        const users = this.state.users
        const po_number = this.state.po_number
        const invoice_number = this.state.invoice_number
        const toDate = this.state.toDate === null ? '' : this.formatDate(this.state.toDate)
        const fromDate = this.state.fromDate === null ? '' : this.formatDate(this.state.fromDate)
        const barcode = this.state.barcode
        console.log(pageNumber, 'pageNumber');
        this.setState({ loading: true })
        try {
            const { data } = await axios.get(`${PathCustom}store/box-label-printed-items/get?page=${pageNumber}&poNumber=${poNumber}&startDate=${toDate}&endDate=${fromDate}&barcode=${barcode}`)
            if (data.data.data.length === 0) {
                this.setState({ loading: false, printingItems: null, paginationData: {} })
                toast.error("No record found")
                return
            }
            var filtering = data?.data?.data
            filtering = filtering.map((item => {
                return {
                    ...item,
                }
            }))
            // filtering = filtering.filter((item => item?.serialNumber !== undefined))
            // filtering = filtering.filter((item => item?.udfs?.Retail_Product_SKUOriginal?.value !== undefined))
            // filtering = filtering.filter((item => item?.udfs?.user?.value !== undefined))
            // filtering = filtering.filter((item => item?.createdAt !== undefined))
            this.setState({ printingItems: filtering, printingItemsFilter: filtering, paginationData: data?.data })
            this.setState({ loading: false })

        } catch (error) {
            this.setState({ loading: false })
            toast.error("Something went wrong")
        }
    }
    async componentDidMount() {
        this.getPrintedItems()
    }

    formatDate = (date) => {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
        // return console.log([year, month, day].join('-'))
    }
    dateFilter = () => {
        var filtering = this.state.printingItemsFilter
        filtering = filtering.filter((item => item?.serialNumber !== undefined))
        filtering = filtering.filter((item => item?.udfs?.Retail_Product_SKUOriginal?.value !== undefined))
        filtering = filtering.filter((item => item?.udfs?.user?.value !== undefined))
        filtering = filtering.filter((item => item?.createdAt !== undefined))
        if (this.state.toDate === null && this.state.fromDate === null) {
            return filtering.filter((x =>
                x?.serialNumber?.toLowerCase().includes(this.state.poNumber.toLowerCase())
                &&
                x?.udfs?.Retail_Product_SKUOriginal?.value?.toLowerCase().includes(this.state.sku.toLowerCase())
                &&
                x?.udfs?.user?.value.toLowerCase().includes(this.state.users.toLowerCase())
            ))
        } else {
            return filtering.filter((x =>
                this.formatDate(x?.createdAt) >= this.formatDate(this.state.toDate) && this.formatDate(x?.createdAt) <= this.formatDate(this.state.fromDate)
                &&
                x?.serialNumber?.toLowerCase().includes(this.state.poNumber.toLowerCase())
                &&
                x?.udfs?.Retail_Product_SKUOriginal?.value?.toLowerCase().includes(this.state.sku.toLowerCase())
                &&
                x?.udfs?.user?.value.toLowerCase().includes(this.state.users.toLowerCase())
            ))
        }
    }
    searchData = async () => {
        this.setState({ loading: true })
        this.setState({ refresh: !this.state.refresh })
        await this.setState({ printingItems: this.dateFilter() })
        console.log(this.dateFilter());
        this.setState({ loading: false })

    }

    downloadCSV = async () => {
        try {
            this.setState({ loading: true })
            const poNumber = this.state.poNumber || '';
            const toDate = this.state.toDate === null ? '' : this.formatDate(this.state.toDate);
            const fromDate = this.state.fromDate === null ? '' : this.formatDate(this.state.fromDate);
            const barcode = this.state.barcode || '';

            const params = new URLSearchParams();
            if (poNumber) params.append('poNumber', poNumber);
            if (toDate) params.append('startDate', toDate);
            if (fromDate) params.append('endDate', fromDate);
            if (barcode) params.append('barcode', barcode);

            const url = `${PathCustom}store/box-label-printed-items/csv?${params.toString()}`;
            
            const response = await axios.get(url, {
                responseType: 'blob',
            });

            const blob = new Blob([response.data], { type: 'text/csv' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `Box_Label_Printed_Items_Report_${new Date().getTime()}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
            this.setState({ loading: false })
            toast.success("CSV downloaded successfully");
        } catch (error) {
            console.error("Error downloading CSV:", error);
            this.setState({ loading: false })
            toast.error("Internal server error. Failed to download CSV.");
        }
    }
    render() {
        const headers = [
            "Created At",
            "Store Id",
            "PO Number",
            "PO Vendor",
            "Carton Number",
            "Manufacture Country",
            "Prefix",
            "User",
        ]
        const colNames = [
            'createdAt',
            'storeId',
            'poNumber',
            "PO_Vendor",
            "barcode",
            "manufactureCountry",
            "prefix",
            "user",
        ]

        return (
            <React.Fragment>
                <Loader loading={this.state.loading} />
                <div className="dashboard-main">
                    <div className='dashboard-top' style={{ display: 'flex', flexDirection: 'column', padding: '10px' }} >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <p className='stock-count' style={{ fontSize: '25px', margin: 0 }}>Box Label Printed Items (Report)</p>
                            <GrDocumentCsv 
                                color='white' 
                                fill='white' 
                                fontSize={25} 
                                style={{ marginRight: 5, cursor: 'pointer' }} 
                                onClick={this.downloadCSV}
                            />
                        </div>
                        <div>
                            <h1 style={{ color: 'black', fontSize: '15px' }}>
                                {new Date().toLocaleString('hi-IN')}
                            </h1>
                        </div>
                    </div>
                    <div className="dashboard-bottom">
                        <div style={{ display: "flex", width: '100%', gridColumnGap: '20px', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                            <div style={{ display: 'flex', gridColumnGap: '10px', flexWrap: 'wrap' }}>
                                {/* <DesktopDatePicker
                                    label="From Date"
                                    inputFormat="DD/MM/YYYY"
                                    clearable
                                    size={'small'}
                                    value={this.state.toDate}
                                    onChange={(data) => this.setState({ toDate: data })}
                                    renderInput={(params) => <TextField sx={{ width: 170 }} size={'small'} {...params} />}
                                />
                                <DesktopDatePicker
                                    label="To Date"
                                    inputFormat="DD/MM/YYYY"
                                    size={'small'}
                                    value={this.state.fromDate}
                                    onChange={(data) => this.setState({ fromDate: data })}
                                    renderInput={(params) => <TextField sx={{ width: 170 }} size={'small'} {...params} />}
                                /> */}

                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    size={'small'}
                                    freeSolo={true}
                                    options={this.state.printingItemsFilter?.map((item => item?.poNumber)).reduce((noDupArr, entry) => {
                                        if (noDupArr?.includes(entry)) {
                                            return noDupArr;
                                        } else {
                                            return [...noDupArr, entry];
                                        }
                                    }, []).filter((item => item !== null && item !== undefined))}
                                    onChange={(e, v) => this.setState({ poNumber: v === null ? '' : v })}
                                    onInputChange={(e, v) => this.setState({ poNumber: (v === null || v === undefined) ? '' : v })}
                                    sx={{ width: 235 }}
                                    renderInput={(params) => <TextField
                                        {...params} label="PO Number" />}
                                />
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    size={'small'}
                                    freeSolo={true}
                                    options={this.state.printingItemsFilter?.map((item => item?.barcode)).reduce((noDupArr, entry) => {
                                        if (noDupArr?.includes(entry)) {
                                            return noDupArr;
                                        } else {
                                            return [...noDupArr, entry];
                                        }
                                    }, []).filter((item => item !== undefined))}
                                    inputValue={this.state.barcode}
                                    onInputChange={(e, v) => this.setState({ barcode: v })}
                                    onChange={(e, v) => this.setState({ barcode: v === null ? '' : v })}
                                    sx={{ width: 250 }}
                                    renderInput={(params) => <TextField
                                        {...params} label="Carton Number" />}
                                />
                            </div>

                            <button onClick={() => this.getPrintedItems()} className="button-custom" >Search</button>
                        </div>

                        <div style={{ paddingTop: "2%" }}>
                            <PaginatedItems
                                pageCountNew={this.state.paginationData?.next + this.state.paginationData?.previous + 1}
                                getData={(pageNumber) => this.getPrintedItems(pageNumber)}
                                totalLength={this.state.paginationData?.next}
                                refresh={this.state.refresh}
                                noAction
                                forcePage={this.state.paginationData.previous || 0}
                                headers={headers}
                                colNames={colNames}
                                itemsPerPage={this.state.itemsPerPage}
                                data={this.state.printingItems?.map((item => {
                                    return {
                                        ...item
                                    }
                                }))}
                            />
                        </div>
                    </div>

                </div>


            </React.Fragment>
        )
    }
}
